'use strict';

const $ = require('jquery');

/**
 * Add scroll listener
 */
let modArticleElements = document.querySelectorAll('.mod_article');
let textTileElements = document.querySelectorAll('.ce_text--tile');
let navigationTile = document.querySelectorAll('.navigation-tile--item');
let iconTile = document.querySelectorAll('.icon_tile--item');

/**
 * Get all elements which are in view
 */
let scrollListener = function() {
    let windowHeight = $(window).height();
    let scrollTop = $('body, html').add($(document.scrollingElement)).scrollTop() + windowHeight * 0.80;

    /**
     * In View effect
     * @param el
     */
    let inViewEffect = function(el) {
        for (let i = 0; el.length > i; i++) {
            let elItem = el[i];
            let elementTop = elItem.offsetTop;

            if (elementTop < scrollTop) {
                elItem.classList.add('in-view');
            } else {
                elItem.classList.remove('in-view');
            }
        }
    };

    inViewEffect(modArticleElements);
    inViewEffect(textTileElements);
    inViewEffect(navigationTile);
    inViewEffect(iconTile);
};

$(window).on('scroll', scrollListener);
scrollListener();
